module.exports = __webpack_public_path__ + "static/media/propic.30e50ca5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/about/propic.jpg
// module id = 38
// module chunks = 0